export default __webpack_public_path__ + "static/media/start_trans.0ac35524.gif";